import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=74481736&"
import script from "./warn.vue?vue&type=script&lang=js&"
export * from "./warn.vue?vue&type=script&lang=js&"
import style0 from "./warn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports